import useContract from './useContract';
import WrappedCompanions from '../contracts/WrappedCompanions.json';

const useWrappedCompanions = () =>
  useContract(
    process.env.NEXT_PUBLIC_WRAPPED_COMPANIONS_CONTRACT_ADDRESS,
    WrappedCompanions.abi
  );

export default useWrappedCompanions;
